<script setup>

import {computed, onMounted} from "vue";
import {useCustomPagesStore} from "@/store/custom-pages";
import {useRoute} from "vue-router";
import MainPreloader from "@/components/shared/MainPreloader.vue";

const customPagesStore =useCustomPagesStore()
const route = useRoute()

onMounted(() => {
  const lastPart = route.path.split('/').pop()
  customPagesStore.loadCustomPage({page_slug:  lastPart })

})

const consentText = computed(() => {
  const html =customPagesStore.record.content
  return html;
})

const loading = computed(() => {
  return customPagesStore.loading
})

</script>

<template>
<div style="text-align: left">
    <MainPreloader
        v-if="loading"
        position="fixed"
        :size="80"
        :stroke="3"
    >

    </MainPreloader>
    <div class="consentText" v-html="consentText"></div>
</div>
</template>

<style scoped lang="scss">
.consentText {
  :deep(p),
  :deep(ul),
  :deep(ol),
  :deep(blockquote) {
    margin: 0 0 1em;
  }

  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5),
  :deep(h6) {
    margin: 1.25em 0 0.5em;
  }

  :deep(li + li) {
    margin-top: 0.25em;
  }

  :deep(a) {
    color: var(--cd-highlight-text);
  }
}
</style>
